import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "@tanstack/react-store";
import { useTranslation } from "react-i18next";
import { store } from "../../../store/store";
import { getQueryStringFromParams } from "../utils/paramUtils";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";
import type { KpisDto } from "./KpisDto";

export function useGetKPIs() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();
    const filters = useSelector(
        store,
        (state) => state.fulfilmentSearchFilters,
    );

    const queryParams = {
        deadlineFrom: filters.deadlineFrom.getTime(),
        deadlineTo: filters.deadlineTo.getTime(),
    };

    const query = useQuery<KpisDto>({
        queryKey: ["useGetKPIs", workspaceId, queryParams],
        queryFn: async () => {
            const queryString = getQueryStringFromParams(queryParams);
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/kpis?${queryString}`,
                { headers },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return response.json();
        },
        enabled: !!workspaceId,
        meta: {
            resourceName: t("errors.resourceName.kpis"),
        },
    });

    return query;
}
